import Vue from "vue";
Vue.component("journal-searchbar-vue", {
  mounted() {
    const crossBtns = this.$el.querySelectorAll(".journal-search-bar__input .searchPill__cross-button");
    const inputFields = this.$el.querySelectorAll(".journal-search-bar__input .searchPill-input");
    const icons = this.$el.querySelectorAll('.searchPill__icon');

    crossBtns.forEach((crossBtn, index) => {
      if (inputFields.length > 0 && crossBtn) {

        inputFields[index].addEventListener('input', () => {
          if (inputFields[index].value !== '') {
            crossBtn.classList.remove('searchPill__cross-button-disable')
          }
          else {
            crossBtn.classList.add('searchPill__cross-button-disable')
          }
        });
        crossBtn.addEventListener("click", function(event) {
          event.preventDefault();
          inputFields[index].value = "";
          crossBtn.classList.add('searchPill__cross-button-disable');
        });

        inputFields[index].addEventListener('focus', () => {
          icons[index].classList.add('search-icon-focus-state');
        });

        inputFields[index].addEventListener('blur', () => {
          icons[index].classList.remove('search-icon-focus-state');
        });
      }
    });
  }
});
